import Tooltip from '@mui/material/Tooltip';

export default function ArrowTooltips({children, text}) {
  return (
    <Tooltip title={text} arrow>
      {children}
    </Tooltip>
  );
}